module.exports = __webpack_public_path__ + "static/media/at04.6f700ca2.jpg";